import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../shared';
import {ProfitCenterContainerModel} from "../../../../../models";
@Injectable({providedIn: 'root'})

export class ProfitCenterService extends BaseApiTemplateService<ProfitCenterContainerModel> {

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'profit-centers';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'profit-centers';
        this.httpClient = http;
  }
}
